<template>
  <div class="card-blank"></div>
</template>

<script>
export default {
  name: 'RowCardFieldBlank',
  height: 16,
}
</script>
